import Image from 'next/image';
import Link from 'next/link';
import { clsx } from 'clsx';
import { SvgArrowMore } from '@/components/icons';
import { Button } from '@/components';
import type { ServiceCardProps } from './serviceCard.types';
import s from './serviceCard.module.scss';

export const ServiceCard = ({ service, backgroundColor, imageSrc, className }: ServiceCardProps) => {
  return (
    <div className={clsx(s.card, className)} style={{ backgroundColor }}>
      <h3 className={s.card__title}>{service?.service_name}</h3>
      <div className={s.card__inner}>
        <Image
          className={s.card__icon}
          src={imageSrc}
          alt="Изображение для услуги"
          height={160}
          width={160}
        />
        <Link href={`/services/${service?.group_id}/${service?.slug ?? service?.id}`}>
          <Button
            name="Подробнее"
            type="button"
            theme="outline2"
            size="medium"
            rightIcon={<SvgArrowMore />}
          />
        </Link>
      </div>
    </div>
  );
};